import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['You start your sessions exhausted, still trying to “figure out” today’s lesson', 'You spend hours of your personal time creating worksheets and materials', 'You keep searching for engaging visual drills that don’t look like they’re from 1990', 'Student participation is low and it’s hard to keep them motivated', 'You struggle to balance grammar rules with real-life conversational flow', 'Your lessons often feel improvised'];
export function ProblemSection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-174" data-mp="35idgbsqo5s6q">
      <div className="mx-auto max-w-4xl text-center" data-id="element-175" data-mp="3jgbtwvx61kl6">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-[#d4af37]" data-id="element-176" data-mp="3jdplku2gb11w">
          The teaching reality
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-177" data-mp="1p1snii9i6wxv">
          If you teach Italian, you probably know these problems.
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-178" data-mp="jd3p4sfl0jtj">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-[#16161F] p-4" data-id="element-179" data-mp="obydsb08d2lk">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-180" data-mp="sd06sa3k0if3" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-181" data-mp="x4rxqlqmgq5r">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-[#d4af37] sm:text-4xl" data-id="element-182" data-mp="125z3ygd49hab">
          How many more evenings do you want to keep sacrificing to planning?
        </p>
      </div>
    </section>;
}